import { Chip } from "@mui/material";
import { FC } from "react";
import { useParams } from "react-router-dom";
import { CustomizedButton } from "../../components/Buttons/CustomizedButton";
import { AdData, AdDataType } from "../../utils/data";
import { conciseAddress } from "../../utils/formatter";
import AdImageViewer from "./AdImageViewer";
import DappDetailPage from "./DappDetailPage";
import DescriptionText from "./DescriptionText";

const AdDetailPage: FC = () => {
  let { id } = useParams();
  const findAd = AdData.find((data) => id == String(data.id));
  let AdDataView: AdDataType = {
    id: 1,
    companyName: "COINBASE GLOBAL, INC",
    status: "approved",
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    description:
      "Coinbase Global, Inc. operates as a secure hosted bitcoin wallet to purchase and use bitcoin. It provides merchant tools that enable companies to accept payments in bitcoin by incorporating a single button. The company was founded by Brian Armstrong in 2012 and is headquartered in San Francisco, CA.",
    postedOn: "18/Nov/2022",
    startDate: "21/Nov/2022",
    EndDate: "25/Nov/2022",
    url: "https://decentradsplatform.web.app/",
    bannerImage: "",
    verticalImage: "",
    SquareImage: "",
    Budget: "1 Eth",
    AdCategory: "Web3",
    AdDuration: "4 days",
    projectLogo: "",
  };
  if (findAd) {
    AdDataView = findAd;
  }

  return (
    <section className="dark:bg-green-900">
      <div className="container px-6 py-10 mx-auto">
        <div className="lg:flex lg:-mx-6">
          <div className="lg:w-3/4 lg:px-6">
            {/* <img
              className="object-cover object-center w-full h-80 xl:h-[28rem] rounded-xl"
              src="https://images.unsplash.com/photo-1624996379697-f01d168b1a52?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
            /> */}
            <div>
              {/* <p className="mt-6 text-sm text-blue-500 uppercase">
                Want to know
              </p> */}
              <h1 className="max-w-lg mt-4 text-4xl font-semibold leading-tight text-gray-800 dark:text-white">
                {AdDataView.companyName}
              </h1>
              <div className="flex items-center mt-6">
                <img
                  className="object-cover object-center w-10 h-10 rounded-full"
                  src={AdDataView.projectLogo}
                />
                <div className="mx-4">
                  <h1 className="text-sm text-gray-700 dark:text-gray-200">
                    {conciseAddress(AdDataView.address)}
                  </h1>
                  <a
                    href={AdDataView.url}
                    className="text-sm text-gray-500 dark:text-gray-400"
                  >
                    {AdDataView.url}
                  </a>
                </div>
              </div>
              <DescriptionText text={AdDataView.description} />
              <AdImageViewer />
            </div>
          </div>
          <div className="mt-8 lg:w-1/4 lg:mt-0 lg:px-6">
            <div className="w-full sticky top-20">
              <div
                className="
         bg-white
         rounded-xl
         relative
         z-10
         overflow-hidden
         border border-primary border-opacity-20
         shadow-pricing
         py-10
         px-8
         sm:p-12
         lg:py-10 lg:px-6
         xl:p-12
         mb-10
         "
              >
                <span className="text-primary text-xl prose-gray font-bold block mb-4">
                  Information
                  <hr />
                </span>

                <div className="mb-7">
                  <span className="text-xl prose-gray font-semibold">
                    Budget:
                  </span>
                  <p className="text-base text-body-color leading-loose mb-1">
                    {AdDataView.Budget}
                  </p>{" "}
                  <span className="text-xl prose-gray font-semibold">
                    Start Date:
                  </span>
                  <p className="text-base text-body-color leading-loose mb-1">
                    {AdDataView.startDate}
                  </p>
                  <span className="text-xl prose-gray font-semibold">
                    End Date:{" "}
                  </span>
                  <p className="text-base text-body-color leading-loose mb-1">
                    {AdDataView.EndDate}{" "}
                  </p>
                  <span className="text-xl prose-gray font-semibold">
                    Status:
                  </span>
                  <br />
                  <Chip
                    label={AdDataView.status}
                    style={{ background: "#2E5242", color: "white" }}
                    className="mb-2"
                  />
                  <br />
                  <span className="text-xl prose-gray font-semibold">
                    Ad Category:
                  </span>
                  <p className="text-base text-body-color leading-loose mb-1">
                    {AdDataView.AdCategory}
                  </p>
                  <span className="text-xl prose-gray font-semibold">
                    Ad Duration:
                  </span>
                  <p className="text-base text-body-color leading-loose mb-1">
                    4 days
                  </p>
                  <span className="text-xl prose-gray font-semibold">
                    IPFS:
                  </span>
                  <p className="text-base text-body-color leading-loose mb-1">
                    Ad IPFS URL
                  </p>
                  <span className="text-xl prose-gray font-semibold">URL:</span>
                  <p className="text-base text-body-color leading-loose mb-1">
                    <a
                      href="https://decentradsplatform.web.app/"
                      target="_blank"
                    >
                      {AdDataView.url}
                    </a>
                  </p>
                </div>
                <CustomizedButton text="Approve" />
                <div>
                  <span className="absolute right-4 top-4 z-[-1]"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdDetailPage;
